// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13258(b66d31fc06)-C06/10/2026-09:02:43-B06/10/2026-09:11:17' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13258(b66d31fc06)-C06/10/2026-09:02:43-B06/10/2026-09:11:17",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13258",
  shortHash: "b66d31fc06",
  longHash: "b66d31fc060d4234dcc01d037b6d05b54a0a26c3",
  dateCommit: "06/10/2026-09:02:43",
  dateBuild: "06/10/2026-09:11:17",
  buildType: "Ansible",
  } ;
